import { Link } from 'react-router-dom';
import { CATEGORY_META } from '@/types/video';

export default function CategoryEntries() {
  return (
    <section className="mx-auto max-w-7xl px-4 pt-12 md:px-8">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {CATEGORY_META.map((cat) => (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group flex items-center gap-4 rounded-lg border border-background-800/80 bg-background-900 p-5 transition-colors hover:border-primary-500/70 hover:bg-background-800/60"
          >
            <span className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-lg bg-primary-500/15 text-primary-400 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${cat.icon} text-3xl`} />
            </span>
            <div className="min-w-0">
              <h3 className="text-base font-semibold text-foreground-50">{cat.name}</h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-400">
                {cat.intro}
              </p>
            </div>
            <i className="ri-arrow-right-s-line ml-auto flex-shrink-0 text-xl text-foreground-500 transition-transform group-hover:translate-x-1 group-hover:text-primary-400" />
          </Link>
        ))}
      </div>
    </section>
  );
}